(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collagen-lander"] && !Shopify.designMode) return;
  try {
    
  // FAQ accordion
  document.querySelectorAll('.lp-root .faq-btn').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var item = btn.closest('.faq-item');
      var isOpen = item.classList.contains('open');
      document.querySelectorAll('.lp-root .faq-item').forEach(function(i) {
        i.classList.remove('open');
        i.querySelector('.faq-btn').setAttribute('aria-expanded', 'false');
      });
      if (!isOpen) {
        item.classList.add('open');
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  });

  // Scroll-reveal for cards
  var revealEls = document.querySelectorAll(
    '.lp-root .benefit-card, .lp-root .testi-card, .lp-root .addon-card, .lp-root .step, .lp-root .hero-badge, .lp-root .pb-stat'
  );
  if ('IntersectionObserver' in window) {
    revealEls.forEach(function(el, i) {
      el.style.cssText += 'opacity:0; transform:translateY(18px); transition:opacity 0.5s ' + (i * 0.06) + 's ease, transform 0.5s ' + (i * 0.06) + 's ease;';
    });
    var io = new IntersectionObserver(function(entries) {
      entries.forEach(function(e) {
        if (e.isIntersecting) {
          e.target.style.opacity = '1';
          e.target.style.transform = 'translateY(0)';
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.12 });
    revealEls.forEach(function(el) { io.observe(el); });
  }

  // Navbar scroll shadow
  var lpNav = document.getElementById('lp-navbar');
  if (lpNav) {
    window.addEventListener('scroll', function() {
      lpNav.style.boxShadow = window.scrollY > 10 ? '0 2px 20px rgba(0,0,0,0.3)' : 'none';
    }, { passive: true });
  }

  // Mute/unmute Lauryn video
  var laurynVid = document.getElementById('lauryn-vid');
  var muteBtn   = document.getElementById('lauryn-mute-btn');
  if (laurynVid && muteBtn) {
    muteBtn.addEventListener('click', function() {
      laurynVid.muted = !laurynVid.muted;
      muteBtn.classList.toggle('is-unmuted', !laurynVid.muted);
      muteBtn.setAttribute('aria-label', laurynVid.muted ? 'Unmute video' : 'Mute video');
    });
  }

  // Paul video — click to play
  (function() {
    var btn     = document.getElementById('paul-play-btn');
    var vid     = document.getElementById('paul-video');
    var overlay = document.getElementById('paul-video-overlay');
    var poster  = document.getElementById('paul-poster');
    var block   = document.getElementById('paul-video-block');
    if (!btn || !vid) return;

    function showVideo() {
      poster.style.opacity  = '0';
      vid.style.opacity     = '1';
      block.classList.add('is-playing');
      overlay.style.opacity = '0';
      overlay.style.pointerEvents = 'none';
    }
    function showPoster() {
      vid.style.opacity     = '0';
      poster.style.opacity  = '1';
      block.classList.remove('is-playing');
      overlay.style.opacity = '1';
      overlay.style.pointerEvents = '';
    }
    function startPlay() {
      vid.currentTime = 0;
      vid.play();
      showVideo();
      vid.addEventListener('ended', function() { showPoster(); vid.currentTime = 0; vid.load(); }, { once: true });
    }

    btn.addEventListener('click', function(e) { e.stopPropagation(); startPlay(); });
    block.addEventListener('click', function() {
      if (!block.classList.contains('is-playing')) return;
      if (vid.paused) { vid.play(); showVideo(); } else { vid.pause(); showPoster(); }
    });
  })();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-v2"] && !Shopify.designMode) return;
  try {
    
  /**
   * Header V2 Component
   * Handles navigation dropdowns and mobile menu interactions
   */
  class HeaderV2 extends HTMLElement {
    constructor() {
      super();
      this.abortController = new AbortController();
      this.activeDropdown = null;
    }

    connectedCallback() {
      this.initialize();
    }

    disconnectedCallback() {
      this.abortController.abort();
    }

    /**
     * Initialize component
     */
    initialize() {
      this.setupDesktopDropdowns();
      this.setupMobileMenu();
      this.setupKeyboardNav();
      this.setupClickOutside();
    }

    /**
     * Setup desktop dropdown interactions
     */
    setupDesktopDropdowns() {
      const triggers = this.querySelectorAll('[data-dropdown-trigger]');

      for (const trigger of triggers) {
        const dropdownId = trigger.dataset.dropdownTrigger;
        const dropdown = this.querySelector(`[data-dropdown="${dropdownId}"]`);

        if (!dropdown) continue;

        const navItem = trigger.parentElement;

        // Hover to open on desktop
        navItem.addEventListener(
          'mouseenter',
          () => {
            if (window.innerWidth >= 769) {
              this.openDropdown(trigger, dropdown);
            }
          },
          { signal: this.abortController.signal }
        );

        navItem.addEventListener(
          'mouseleave',
          () => {
            if (window.innerWidth >= 769) {
              this.closeDropdown(trigger, dropdown);
            }
          },
          { signal: this.abortController.signal }
        );

        // Enter key to toggle for keyboard users
        trigger.addEventListener(
          'keydown',
          (e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              this.toggleDropdown(trigger, dropdown);
            }
          },
          { signal: this.abortController.signal }
        );
      }
    }

    /**
     * Toggle dropdown open/closed
     * @param {HTMLElement} trigger
     * @param {HTMLElement} dropdown
     */
    toggleDropdown(trigger, dropdown) {
      const isOpen = !dropdown.hasAttribute('hidden');

      if (isOpen) {
        this.closeDropdown(trigger, dropdown);
      } else {
        this.closeAllDropdowns();
        this.openDropdown(trigger, dropdown);
      }
    }

    /**
     * Open dropdown
     * @param {HTMLElement} trigger
     * @param {HTMLElement} dropdown
     */
    openDropdown(trigger, dropdown) {
      dropdown.removeAttribute('hidden');
      trigger.setAttribute('aria-expanded', 'true');
      this.activeDropdown = { trigger, dropdown };
    }

    /**
     * Close dropdown
     * @param {HTMLElement} trigger
     * @param {HTMLElement} dropdown
     */
    closeDropdown(trigger, dropdown) {
      dropdown.setAttribute('hidden', '');
      trigger.setAttribute('aria-expanded', 'false');
      if (this.activeDropdown?.dropdown === dropdown) {
        this.activeDropdown = null;
      }
    }

    /**
     * Close all dropdowns
     */
    closeAllDropdowns() {
      const dropdowns = this.querySelectorAll('.header-v2__dropdown');
      const triggers = this.querySelectorAll('[data-dropdown-trigger]');

      for (const dropdown of dropdowns) {
        dropdown.setAttribute('hidden', '');
      }

      for (const trigger of triggers) {
        trigger.setAttribute('aria-expanded', 'false');
      }

      this.activeDropdown = null;
    }

    /**
     * Setup mobile menu toggle
     */
    setupMobileMenu() {
      const toggle = this.querySelector('.header-v2__mobile-toggle');
      const menu = this.querySelector('.header-v2__mobile-menu');

      if (!toggle || !menu) return;

      toggle.addEventListener(
        'click',
        () => {
          const isOpen = !menu.hasAttribute('hidden');

          if (isOpen) {
            // Close menu
            menu.setAttribute('hidden', '');
            toggle.setAttribute('aria-expanded', 'false');
            toggle.setAttribute('aria-label', 'Open mobile menu');

            // Restore scroll
            document.body.style.overflow = '';
            document.documentElement.style.overflow = '';
          } else {
            // Open menu
            menu.removeAttribute('hidden');
            toggle.setAttribute('aria-expanded', 'true');
            toggle.setAttribute('aria-label', 'Close mobile menu');

            // Lock scroll using overflow hidden
            document.body.style.overflow = 'hidden';
            document.documentElement.style.overflow = 'hidden';
          }
        },
        { signal: this.abortController.signal }
      );
    }

    /**
     * Setup keyboard navigation
     */
    setupKeyboardNav() {
      document.addEventListener(
        'keydown',
        (e) => {
          // Escape to close dropdowns
          if (e.key === 'Escape') {
            this.closeAllDropdowns();

            // Close mobile menu
            const toggle = this.querySelector('.header-v2__mobile-toggle');
            const menu = this.querySelector('.header-v2__mobile-menu');
            if (toggle && menu && !menu.hasAttribute('hidden')) {
              menu.setAttribute('hidden', '');
              toggle.setAttribute('aria-expanded', 'false');

              // Restore scroll
              document.body.style.overflow = '';
              document.documentElement.style.overflow = '';
            }
          }
        },
        { signal: this.abortController.signal }
      );
    }

    /**
     * Close dropdowns when clicking outside
     */
    setupClickOutside() {
      document.addEventListener(
        'click',
        (e) => {
          if (!this.activeDropdown) return;

          const { trigger, dropdown } = this.activeDropdown;

          if (!trigger.contains(e.target) && !dropdown.contains(e.target)) {
            this.closeDropdown(trigger, dropdown);
          }
        },
        { signal: this.abortController.signal }
      );
    }

  }

  customElements.define('header-v2', HeaderV2);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lineage-listicle-lander"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  var root = document.querySelector('.lineage-lp');
  if (!root) return;

  /* ---- Light Labs widget loader (mirrors the PDP app embed; guarded so it loads once) ---- */
  if (document.querySelector('lightlabs-widget') && !window.__lightlabsScriptLoaded) {
    window.__lightlabsScriptLoaded = true;
    var llScript = document.createElement('script');
    llScript.async = true;
    llScript.src = 'https://app.lightlabs.com/assets/ll-pip-widget-v5.js';
    document.head.appendChild(llScript);
  }

  /* ---- Nutrition helpers (flavor data comes from the buy-box snippet's lp-bar-data) ---- */
  function lpEsc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }
  // Parse "Label | Amount | %DV" rows into { label, amount, dv } (%DV optional).
  function lpParseRows(arr) {
    return (arr || []).map(function (s) {
      var p = String(s).split('|');
      return { label: (p[0] || '').trim(), amount: (p[1] || '').trim(), dv: (p[2] || '').trim() };
    });
  }
  // Re-apply the FDA-style emphasis/indent to recognised nutrition labels (unknown labels render flat).
  var LP_MAIN = ['total fat', 'cholesterol', 'sodium', 'total carbohydrate', 'protein'];
  var LP_SUB = ['saturated fat', 'trans fat', 'dietary fiber', 'total sugars', 'total sugar'];
  function lpRowClass(label) {
    var l = label.toLowerCase();
    if (l === 'protein') return 'nfp__row nfp__row--pro';
    if (l.indexOf('added sugar') >= 0) return 'nfp__row nfp__row--sub2';
    if (LP_SUB.indexOf(l) >= 0) return 'nfp__row nfp__row--sub';
    return 'nfp__row';
  }
  function lpRowBold(label) { return LP_MAIN.indexOf(label.toLowerCase()) >= 0; }

  function setText(id, v) { var el = document.getElementById(id); if (el) el.textContent = v; }

  function applyFlavor(flavor) {
    var d = BAR_DATA[flavor];
    if (!d) return;
    setText('flavorName', d.flavorName);
    setText('h2Flavor', d.flavorName);
    setText('flavorHint', d.tasting || '');
    setText('nutriTitle', "What's Inside · " + (d.flavorName || ''));
    setText('nutriPill', d.flavorName || '');
    setText('nfpServing', d.serving || '');

    var list = document.getElementById('ingList');
    if (list) {
      var ings = String(d.ingredients || '').split('\n').filter(function (x) { return x.trim() !== ''; });
      list.innerHTML = ings.map(function (i) {
        return '<li><span>' + lpEsc(i.trim()) + '</span></li>';
      }).join('') + (d.allergens ? '<li><span><b>Contains:</b> ' + lpEsc(d.allergens) + '</span></li>' : '');
    }

    var rows = lpParseRows(d.nutrition);
    var cal = '';
    var rowHtml = '';
    rows.forEach(function (r) {
      if (r.label.toLowerCase() === 'calories') { cal = r.amount; return; }
      var lab = lpRowBold(r.label) ? '<b>' + lpEsc(r.label) + '</b>' : lpEsc(r.label);
      var dv = r.dv ? '<span class="dv">' + lpEsc(r.dv) + '</span>' : '<span></span>';
      rowHtml += '<div class="' + lpRowClass(r.label) + '"><span>' + lab + ' <span>' + lpEsc(r.amount) + '</span></span>' + dv + '</div>';
    });
    setText('nfp-cal', cal);
    var box = document.getElementById('nfpRows');
    if (box) box.innerHTML = rowHtml;
  }

  /* ---- live product data + i18n (rendered by the buy-box snippet) ---- */
  function parseJSON(id, fallback) {
    var el = document.getElementById(id);
    if (!el) return fallback;
    try { return JSON.parse(el.textContent); } catch (e) { return fallback; }
  }
  var BAR_DATA = parseJSON('lp-bar-data', {});
  var I18N = parseJSON('lp-i18n', {});

  function money(cents) {
    if (cents == null || isNaN(cents)) return '';
    return '$' + (cents / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
  function fmt(tpl, pct) { return (tpl || '').replace('{pct}', pct); }

  /* ---- buy-box controller: flavor → product, size → variant, plan → Skio selling plan ---- */
  var BAR_KEYS = Object.keys(BAR_DATA);
  var state = { flavor: BAR_KEYS[0] || '', size: '12', plan: 'sub' };
  var form = document.getElementById('lpBuyForm');
  var elVariant = document.getElementById('lpVariantId');
  var elPlan = document.getElementById('lpSellingPlan');
  var addBtn = document.getElementById('lpAddBtn');
  var qtySeg = document.getElementById('qtySeg');
  var qtyThumb = qtySeg ? qtySeg.querySelector('.pill-seg__thumb') : null;
  var galleryMain = document.getElementById('lpGalleryMain');
  var thumbsWrap = document.getElementById('lpThumbs');

  // initial pack comes from the Liquid-rendered active button (the "Default pack" setting)
  var initQty = qtySeg ? qtySeg.querySelector('.opt.active') : null;
  if (initQty) state.size = initQty.getAttribute('data-v');

  function currentVariant() {
    var f = BAR_DATA[state.flavor];
    if (!f || !f.sizes) return null;
    return f.sizes[state.size] || null;
  }

  function moveThumb() {
    if (!qtySeg || !qtyThumb) return;
    var a = qtySeg.querySelector('.opt.active');
    if (!a) return;
    qtyThumb.style.left = a.offsetLeft + 'px';
    qtyThumb.style.top = a.offsetTop + 'px';
    qtyThumb.style.width = a.offsetWidth + 'px';
    qtyThumb.style.height = a.offsetHeight + 'px';
  }

  /* gallery — main image + thumbnails come from the selected product's images */
  function selectThumb(btn, fullSrc) {
    if (galleryMain && fullSrc) galleryMain.src = fullSrc;
    if (!thumbsWrap) return;
    thumbsWrap.querySelectorAll('.thumb').forEach(function (t) { t.classList.remove('is-active'); });
    if (btn) btn.classList.add('is-active');
  }
  function updateGallery() {
    var f = BAR_DATA[state.flavor];
    if (!f || !f.images || !f.images.length || !thumbsWrap) return;
    if (galleryMain) {
      galleryMain.src = f.images[0].m;
      galleryMain.alt = f.alt || '';
    }
    thumbsWrap.innerHTML = '';
    f.images.forEach(function (img, i) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'thumb' + (i === 0 ? ' is-active' : '');
      btn.setAttribute('data-full', img.m);
      btn.setAttribute('aria-label', (I18N.viewImage || 'View image {n}').replace('{n}', i + 1));
      var im = document.createElement('img');
      im.src = img.t; im.alt = ''; im.loading = 'lazy'; im.width = 64; im.height = 74;
      btn.appendChild(im);
      btn.addEventListener('click', function () { selectThumb(btn, img.m); });
      thumbsWrap.appendChild(btn);
    });
  }
  /* wire the Liquid-rendered initial thumbnails (before any flavor change) */
  if (thumbsWrap) {
    thumbsWrap.querySelectorAll('.thumb').forEach(function (btn) {
      btn.addEventListener('click', function () { selectThumb(btn, btn.getAttribute('data-full')); });
    });
  }

  function render() {
    var v = currentVariant();
    if (!v) return;
    var bars = parseInt(v.bars, 10) || 1;
    var base = v.once;                          // live Shopify base price per pack (cents)
    var subPct = Number(I18N.subPct) || 0;      // sale percentages (editable config)
    var oncePct = Number(I18N.oncePct) || 0;
    var renewalPct = Number(I18N.renewalPct) || 0;
    var hasPlan = v.subPlanId != null;
    var oncePrice = Math.round(base * (100 - oncePct) / 100);
    var renewalPrice = Math.round(base * (100 - renewalPct) / 100);
    // Subscribe FIRST order = the subscription (renewal) price with the funnel code
    // (oncePct) stacked on top — mirrors Shopify (plan discount, then the code).
    var subPrice = renewalPrice - Math.round(renewalPrice * oncePct / 100);

    // hidden inputs the cart reads
    if (elVariant) elVariant.value = v.variantId;
    if (elPlan) elPlan.value = (state.plan === 'sub' && hasPlan) ? v.subPlanId : '';

    // recommended badge
    setText('planRecommended', fmt(I18N.recommendedFmt, subPct));

    // subscribe card
    setText('planSubPrice', money(subPrice));
    var subWas = document.getElementById('planSubWas');
    if (subWas) { subWas.textContent = money(base); subWas.hidden = false; }
    setText('planSubPer', money(Math.round(subPrice / bars)) + ' ' + (I18N.perBar || '/ bar'));
    setText('planSubMeta', bars + ' ' + (I18N.barsWord || 'bars') + ' · ' + (I18N.shipsEvery || ''));
    var subEm = document.getElementById('planSubSaveEm');
    if (subEm) subEm.textContent = fmt(I18N.subOffFmt, subPct);
    var renewalEl = document.getElementById('planSubRenewal');
    if (renewalEl) renewalEl.textContent = (I18N.renewalFmt || '').replace('{pct}', renewalPct).replace('{price}', money(renewalPrice));

    // one-time card
    setText('planOncePrice', money(oncePrice));
    var onceWas = document.getElementById('planOnceWas');
    if (onceWas) { onceWas.textContent = money(base); onceWas.hidden = false; }
    setText('planOncePer', money(Math.round(oncePrice / bars)) + ' ' + (I18N.perBar || '/ bar'));
    setText('planOnceMeta', bars + ' ' + (I18N.barsWord || 'bars') + ' · ' + (I18N.noSub || ''));
    var onceEm = document.getElementById('planOnceSaveEm');
    if (onceEm) onceEm.textContent = fmt(I18N.offFmt, oncePct);

    // CTA
    var chosenPrice = (state.plan === 'sub') ? subPrice : oncePrice;
    var chosenPct = (state.plan === 'sub') ? subPct : oncePct;
    setText('ctaPrice', money(chosenPrice));
    var ctaSaveEl = document.getElementById('ctaSave');
    if (ctaSaveEl) {
      if (chosenPct > 0) { ctaSaveEl.textContent = fmt(I18N.saveFmt, chosenPct); ctaSaveEl.hidden = false; }
      else { ctaSaveEl.hidden = true; }
    }

    // availability
    if (addBtn) {
      var main = addBtn.querySelector('.sn-main');
      if (!v.available) {
        addBtn.disabled = true;
        if (main) main.textContent = I18N.soldOut || 'Sold Out';
      } else {
        addBtn.disabled = false;
      }
    }
  }

  /* flavor (also drives nutrition modal text via applyFlavor) */
  var flavorCards = document.querySelectorAll('#flavors .flavor');
  flavorCards.forEach(function (card) {
    card.addEventListener('click', function () {
      flavorCards.forEach(function (x) { x.classList.remove('active'); x.setAttribute('aria-checked', 'false'); });
      card.classList.add('active');
      card.setAttribute('aria-checked', 'true');
      state.flavor = card.getAttribute('data-flavor');
      applyFlavor(state.flavor);
      render();
      updateGallery();
    });
  });

  /* quantity → Size variant */
  if (qtySeg) {
    var qopts = qtySeg.querySelectorAll('.opt');
    qopts.forEach(function (o) {
      o.addEventListener('click', function () {
        qopts.forEach(function (x) { x.classList.remove('active'); x.setAttribute('aria-checked', 'false'); });
        o.classList.add('active');
        o.setAttribute('aria-checked', 'true');
        state.size = o.getAttribute('data-v');
        moveThumb();
        render();
      });
    });
    window.addEventListener('resize', moveThumb);
    window.addEventListener('load', moveThumb);
  }

  /* plan → subscribe vs one-time */
  var plans = document.querySelectorAll('#plans .plan');
  function selectPlan(p) {
    plans.forEach(function (x) { x.classList.remove('active'); x.setAttribute('aria-checked', 'false'); });
    p.classList.add('active');
    p.setAttribute('aria-checked', 'true');
    state.plan = p.getAttribute('data-plan');
    render();
  }
  plans.forEach(function (p) {
    p.addEventListener('click', function () { selectPlan(p); });
    p.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') { e.preventDefault(); selectPlan(p); }
    });
  });

  /* add to cart — AJAX (progressive enhancement over the native form POST) */
  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var v = currentVariant();
      if (!v || !v.available || !addBtn) return;
      var cartUrl = form.getAttribute('data-cart-url') || '/cart';
      var item = { id: v.variantId, quantity: 1 };
      if (state.plan === 'sub' && v.subPlanId) item.selling_plan = v.subPlanId;
      addBtn.classList.add('is-loading');
      addBtn.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [item] })
      }).then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return r.json();
      }).then(function () {
        document.dispatchEvent(new CustomEvent('lineage:cart-added', { detail: item, bubbles: true }));
        window.location.href = cartUrl;
      }).catch(function () {
        // fall back to a native form POST so checkout still works
        addBtn.classList.remove('is-loading');
        form.submit();
      });
    });
  }

  // initial paint (mirrors the Liquid-rendered defaults)
  applyFlavor(state.flavor);
  moveThumb();
  render();
  updateGallery();

  /* ---- Auto-apply funnel discount ----
     The theme's cart drawer intercepts add-to-cart, so a redirect on submit
     never fires. Instead we register the code with Shopify's cart session on
     load (and again after any add we observe). Routing through ?redirect=/cart.js
     applies the code and returns the (small) cart JSON, so it sticks in the cart
     and at checkout no matter how items are added. */
  (function () {
    if (!form || !window.fetch) return;
    var code = form.getAttribute('data-discount-code');
    if (!code) return;
    var url = '/discount/' + encodeURIComponent(code) + '?redirect=/cart.js';
    function applyDiscount() {
      try { fetch(url, { credentials: 'same-origin', cache: 'no-store' }); } catch (e) {}
    }
    applyDiscount();
    document.addEventListener('lineage:cart-added', applyDiscount);
  })();

  /* ---- nutrition label modal (focus-managed dialog) ---- */
  var modal = document.getElementById('nutriModal');
  var openBtn = document.getElementById('viewLabelBtn');
  var lastFocus = null;
  function focusables() {
    if (!modal) return [];
    return Array.prototype.slice.call(modal.querySelectorAll('a[href],button:not([disabled]),input,[tabindex]:not([tabindex="-1"])'));
  }
  function openModal() {
    if (!modal) return;
    lastFocus = document.activeElement;
    modal.hidden = false;
    document.body.style.overflow = 'hidden';
    var f = focusables();
    if (f.length) f[0].focus();
  }
  function closeModal() {
    if (!modal) return;
    modal.hidden = true;
    document.body.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  if (openBtn) openBtn.addEventListener('click', openModal);
  if (modal) {
    modal.querySelectorAll('[data-nutri-close]').forEach(function (el) { el.addEventListener('click', closeModal); });
    document.addEventListener('keydown', function (e) {
      if (modal.hidden) return;
      if (e.key === 'Escape') { closeModal(); return; }
      if (e.key === 'Tab') {
        var f = focusables();
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });
  }

  /* ---- accordions ---- */
  function measure(c) { return (c.scrollHeight + 40) + 'px'; }
  document.querySelectorAll('#accordions .acc').forEach(function (acc) {
    var h = acc.querySelector('.acc-h');
    var c = acc.querySelector('.acc-c');
    if (!h || !c) return;
    if (acc.classList.contains('open')) c.style.maxHeight = measure(c);
    h.addEventListener('click', function () {
      var open = acc.classList.toggle('open');
      h.setAttribute('aria-expanded', open ? 'true' : 'false');
      c.style.maxHeight = open ? measure(c) : '0px';
    });
  });
  window.addEventListener('load', function () {
    document.querySelectorAll('#accordions .acc.open .acc-c').forEach(function (c) {
      c.style.maxHeight = (c.scrollHeight + 40) + 'px';
    });
  });

  /* ---- testimonial carousel (mobile scroll-snap) ---- */
  (function () {
    var track = document.getElementById('testiTrack');
    var dots = document.querySelectorAll('.testi-nav .dots i');
    var prev = document.getElementById('tPrev');
    var next = document.getElementById('tNext');
    if (!track) return;
    var cards = track.querySelectorAll('.tcard');
    function current() {
      var best = 0, bestDist = Infinity;
      var base = track.getBoundingClientRect().left;
      cards.forEach(function (c, i) {
        var d = Math.abs(c.getBoundingClientRect().left - base);
        if (d < bestDist) { bestDist = d; best = i; }
      });
      return best;
    }
    function setDots(i) { dots.forEach(function (d, n) { d.classList.toggle('on', n === i); }); }
    function goTo(i) {
      i = Math.max(0, Math.min(cards.length - 1, i));
      var card = cards[i];
      if (!card) return;
      track.scrollTo({ left: card.offsetLeft - track.offsetLeft, behavior: 'smooth' });
      setDots(i);
    }
    if (prev) prev.addEventListener('click', function () { goTo(current() - 1); });
    if (next) next.addEventListener('click', function () { goTo(current() + 1); });
    var raf;
    track.addEventListener('scroll', function () {
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () { setDots(current()); });
    });
    dots.forEach(function (d, i) { d.style.cursor = 'pointer'; d.addEventListener('click', function () { goTo(i); }); });
  })();
})();

  } catch(e) { console.error(e); }
})();
})();
